var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "kompa-product-form uk-form-stacked",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('text-input', {
    ref: "name",
    attrs: {
      "label": _vm.$t('fields.name') + '*',
      "errors": _vm.form.errors.name,
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.form.model.name),
      callback: function($$v) {
        _vm.form.model.name = $$v
      },
      expression: "form.model.name"
    }
  }), _vm._v(" "), _c('keyword-list-input', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.form.errors.eanList,
      "label": _vm.$t('fields.eanList')
    },
    model: {
      value: (_vm.form.model.eanList),
      callback: function($$v) {
        _vm.form.model.eanList = $$v
      },
      expression: "form.model.eanList"
    }
  }), _vm._v(" "), _c('product-family-combobox', {
    attrs: {
      "label": _vm.$t('fields.family'),
      "errors": _vm.form.errors.family,
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.form.model.family),
      callback: function($$v) {
        _vm.form.model.family = $$v
      },
      expression: "form.model.family"
    }
  }), _vm._v(" "), _c('text-input', {
    ref: "brand",
    attrs: {
      "label": _vm.$t('fields.brand') + '*',
      "errors": _vm.form.errors.brand,
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.form.model.brand),
      callback: function($$v) {
        _vm.form.model.brand = $$v
      },
      expression: "form.model.brand"
    }
  }), _vm._v(" "), _c('text-input', {
    ref: "manufacturer_part_number",
    attrs: {
      "label": _vm.$t('fields.manufacturerPartNumber'),
      "errors": _vm.form.errors.manufacturerPartNumber,
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.form.model.manufacturerPartNumber),
      callback: function($$v) {
        _vm.form.model.manufacturerPartNumber = $$v
      },
      expression: "form.model.manufacturerPartNumber"
    }
  }), _vm._v(" "), _c('text-input', {
    ref: "priority",
    attrs: {
      "type": "number",
      "min": 0,
      "max": 100,
      "step": 1,
      "label": _vm.$t('fields.priority'),
      "errors": _vm.form.errors.priority,
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.form.model.priority),
      callback: function($$v) {
        _vm.form.model.priority = _vm._n($$v)
      },
      expression: "form.model.priority"
    }
  }), _vm._v(" "), _c('keyword-list-input', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.form.errors.compatibleAppVersions,
      "label": _vm.$t('fields.compatibleAppVersions'),
      "options": ['MSHPro', 'MSHFree', 'MZAPro', 'MZABasic']
    },
    model: {
      value: (_vm.form.model.compatibleAppVersions),
      callback: function($$v) {
        _vm.form.model.compatibleAppVersions = $$v
      },
      expression: "form.model.compatibleAppVersions"
    }
  }), _vm._v(" "), _c('keyword-list-input', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.form.errors.compatibleBaseStations,
      "label": _vm.$t('fields.compatibleBaseStations'),
      "options": ['1', '2', '3', '4']
    },
    model: {
      value: (_vm.form.model.compatibleBaseStations),
      callback: function($$v) {
        _vm.form.model.compatibleBaseStations = $$v
      },
      expression: "form.model.compatibleBaseStations"
    }
  }), _vm._v(" "), _c('checkbox', {
    ref: "primaryInput",
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.form.errors.connectionRequired,
      "label": _vm.$t('fields.connectionRequired')
    },
    model: {
      value: (_vm.form.model.connectionRequired),
      callback: function($$v) {
        _vm.form.model.connectionRequired = $$v
      },
      expression: "form.model.connectionRequired"
    }
  }), _vm._v(" "), _c('text-input', {
    ref: "connectionRequiredLabel",
    attrs: {
      "label": _vm.$t('fields.connectionRequiredLabel'),
      "errors": _vm.form.errors.connectionRequiredLabel,
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.form.model.connectionRequiredLabel),
      callback: function($$v) {
        _vm.form.model.connectionRequiredLabel = $$v
      },
      expression: "form.model.connectionRequiredLabel"
    }
  }), _vm._v(" "), _c('text-input', {
    ref: "extension",
    attrs: {
      "label": _vm.$t('fields.extension'),
      "errors": _vm.form.errors.extension,
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.form.model.extension),
      callback: function($$v) {
        _vm.form.model.extension = $$v
      },
      expression: "form.model.extension"
    }
  }), _vm._v(" "), _c('fieldset', {
    staticClass: "uk-fieldset uk-margin-medium-top"
  }, [_c('legend', {
    staticClass: "uk-legend uk-margin"
  }, [_vm._v(_vm._s(_vm.$t('fieldsets.media')))]), _vm._v(" "), _c('attachment-manager', {
    attrs: {
      "disabled": !_vm.isEditable,
      "attachment-type": "MEDIA_OBJECT"
    },
    model: {
      value: (_vm.form.model.attachments),
      callback: function($$v) {
        _vm.form.model.attachments = $$v
      },
      expression: "form.model.attachments"
    }
  })], 1), _vm._v(" "), _c('submit-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.isSubmittable
    }
  }), _vm._v(" "), _c('cancel-button')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64d2af34","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/KompaProductForm.vue
// module id = 2024
// module chunks = 0